import React, { useContext, useState } from "react";
// React Bootstrap
import { Accordion, Card, Button } from "react-bootstrap";
// // Contexto
import { ModalContext } from "../../../context/modalContext";
import { AlertBoxContext } from "../../../context/alertBoxContext";
import { ConfirmModalContext } from "../../../context/confirmModalContext";

// jquery
import $ from "jquery";
// Custom spinner
import CustomSpinner from "../../generic/CustomSpinner";
// Form

// Contexto
import { tipoSituacionesParticularesObj } from "../../../contexto";
import VistaSituacionParticular from "../vistas/VistaSituacionParticular";
import { dateToString2 } from "../../../utils";
import EditSituacionParticular from "../formularios/SituacionParticularEdit";

const SituacionParticular = ({ deleteSituacionParticularState, accessLevel, ...props }) => {
  // Modal
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
  // Custom spinner
  const [loading, setLoading] = useState(false);
  // Alertas
  const { addAlert } = useContext(AlertBoxContext);
  // Ventana de confirmación
  const { confirmModalSetShow, confirmModalSetTitle, confirmModalSetContent, confirmModalSetFunction } = useContext(ConfirmModalContext);
  // UEF para guardar los datos de la participacion
  const [situacionParticular, setSituacionParticular] = useState(props.situacionParticular);

  // Elimina una participación de una comunidad
  const deleteSituacionParticular = () => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/hermanas/${situacionParticular.sisterId}/situacionesParticulares/${situacionParticular.id}`,
      method: "DELETE",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  // Manejador para el delete de los datos de las participaciones de la comunidad
  const handleDeleteSituacionParticular = () => {
    setLoading(true);
    // Hacemos el delete para los datos de las participaciones
    deleteSituacionParticular()
      .then((response) => {
        deleteSituacionParticularState(situacionParticular.id);
        addAlert("Exito", "Se ha eliminado correctamente la situacion particular", "success");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        addAlert("Error", "No se ha podido eliminar la situacion particular", "danger");
      });
  };

  const putSituacionParticular = (data) => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/hermanas/${situacionParticular.sisterId}/situacionesParticulares/${situacionParticular.id}`,
      method: "PUT",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  const handlePutSituacionParticular = (data) => {
    modalSetShow(false);
    setLoading(true);
    // Hacemos el delete para los datos de las participaciones
    putSituacionParticular(data)
      .then((response) => {
        setSituacionParticular(response);
        addAlert("Exito", "Se ha editado correctamente la situacion particular", "success");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        addAlert("Error", "No se ha podido editar la situacion particular", "danger");
      });
  };

  return (
    <div className="position-relative">
      <CustomSpinner animation={"border"} loading={loading} />

      <Accordion defaultActiveKey="1" className={"mb-2"}>
        <Card>
          <Card.Header>
            <Accordion.Toggle eventKey="0" as={Button} variant="link">
              {tipoSituacionesParticularesObj[situacionParticular?.type]}
            </Accordion.Toggle>

            {accessLevel > 2 && (
              <Button
                onClick={() => {
                  confirmModalSetShow(true);
                  confirmModalSetTitle(`Eliminar situación particular (${tipoSituacionesParticularesObj[situacionParticular?.type]})`);
                  confirmModalSetContent(<p> {"¿Está seguro de que quiere eliminarla?"} </p>);
                  confirmModalSetFunction(() => {
                    handleDeleteSituacionParticular();
                  });
                }}
                variant="outline-danger"
                size="sm"
                className="float-right mr-4"
              >
                Eliminar
              </Button>
            )}
            {(situacionParticular.endDate === null || dateToString2(new Date(situacionParticular.endDate)) > dateToString2(new Date())) && accessLevel > 2 && (
              <Button
                variant="outline-primary"
                size="sm"
                className="float-right mr-3"
                onClick={() => {
                  modalSetShow(true, "80%");
                  modalSetTitle("Editar situación particular");
                  modalSetContent(<EditSituacionParticular situacionParticular={situacionParticular} submissionHandler={handlePutSituacionParticular} />);
                }}
              >
                Editar
              </Button>
            )}
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <VistaSituacionParticular datosSituacionParticular={situacionParticular} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default SituacionParticular;
